<template>
  <div
    class="modal modal-sign-offs-create fade fixed-end"
    tabindex="-1"
    role="dialog"
  >
    <div
      class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="drawer-title">
            {{ title }}
          </h2>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <!-- /.drawer-heading -->

        <div class="modal-body">
          <div class="mb-3">
            <label class="control-label">Select Client</label>
            <div class="input-group">
              <span class="input-group-text"
                ><i class="fal fa-fw fa-building"></i
              ></span>
              <div class="flex-grow-1">
                <multiselect
                  :show-labels="false"
                  v-model="client"
                  :options="clients"
                  label="company"
                  track-by="id"
                  placeholder=""
                  v-validate="'required'"
                  data-vv-name="client"
                  @select="clientSelected"
                ></multiselect>
              </div>
            </div>
            <help-block field="client" />
          </div>
          <!-- /.form-group -->

          <div class="mb-3">
            <label class="control-label">Name</label>
            <input
              name="name"
              v-model="newStack.name"
              type="text"
              class="form-control"
              data-vv-validate-on="input|blur"
              data-vv-as="name"
              v-validate="'required'"
            />
            <help-block field="name" />
          </div>

          <div class="mb-3">
            <label class="control-label">Pre-Paid Credit</label>
             <div class="input-group">
              <span class="input-group-text">$</span>
              <div class="flex-grow-1">
                <input
                  name="pre_paid_credit"
                  v-model="newStack.pre_paid_credit"
                  type="number"
                  class="form-control"
                  data-vv-validate-on="input|blur"
                  data-vv-as="name"
                  v-validate="'decimal'"
                />
              </div>
            </div>
            <help-block field="pre_paid_credit" />
          </div>

          <div class="mb-3">
            <label class="control-label">Pi Monthly Total</label>
            <div class="input-group">
              <span class="input-group-text">$</span>
              <div class="flex-grow-1">
                <input
                  name="pi_monthly_total"
                  v-model="newStack.pi_monthly_total"
                  type="number"
                  class="form-control"
                  data-vv-validate-on="input|blur"
                  data-vv-as="name"
                  v-validate="'decimal'"
                />
                </div>
              </div> 
            <help-block field="pi_monthly_total" />
          </div>

          <div class="mb-3">
            <label class="control-label">Pi Service <span class="small">Link to the PI service (URL)</span></label>
            <div class="input-group">
              <span class="input-group-text">https://</span>
              <div class="flex-grow-1">
                <input
                  name="pi_service"
                  v-model="newStack.pi_service"
                  type="text"
                  class="form-control"
                  data-vv-validate-on="input|blur"
                  data-vv-as="name"
                  v-validate="'required'"
                />
              </div>
            </div>
            <help-block field="pi_service" />
          </div>

          <div class="mb-3">
            <label class="control-label">Auto Bill</label>
            <c-checkbox
                v-model="newStack.auto_bill"
                label=""
              />
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <c-button @click="handleSave" class="btn btn-rounded btn-primary"
              >Save</c-button
            >
          </div>
        </div>
        <!-- /.drawer-body -->
      </div>
      <!-- /.drawer-contents -->
    </div>
  </div>
  <!-- /.drawer -->
</template>

<style scoped>
.invalid-feedback {
  display: inline-block;
}
</style>

<style>
.form-control {
  box-shadow: none !important;
}

.form-control[readonly] {
  background-color: transparent !important;
}
</style>

<script>
import { notify } from "utils";
import { cloneDeep } from "lodash";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";
import { mapActions, mapState, mapGetters } from "vuex";
import { Selectize, LaddaButton } from "components/form/input";
import { helperMethods } from "vx/modules/clients";
import { CModal } from "@chameleon/chameleon-vue";

export default {
  $_veeValidate: {
    validator: "new", // give me my own validator scope.
  },
  props: ["title", "stack", "mode"],
  extends: CModal,
  components: {
    Selectize,
    LaddaButton,
    Datepicker,
    Multiselect,
  },

  data() {
    return {
      newStack: {},
      client: null,
      awsAccountOptions: []
    };
  },

  mounted() {
    this.getClients();

    this.addEventListener('open', () => {
      this.newStack = cloneDeep(this.stack);

      if (
        this.newStack 
      ) {
        this.client = this.getClientById(this.newStack.client_id);
      }
    });
  },

  computed: {
    ...mapState("clientsList", ["clients"]),
    ...mapGetters("clientsList", { getClientById: "getById" })
  },
  methods: {
    ...helperMethods,
    ...mapActions("stack", ["addSingle", "updateSingle"]),
    ...mapActions("clientsList", ["getClients"]),

    clientSelected(selected) {
      this.newStack.client_id = selected.id
    },

    awsAccountSelected(selected) {
      this.newStack.aws_accounts.push({'aws_account_id': selected})
      console.log(selected)
    },

    handleSave() {
      if (this.newStack.id) {
        return this.handleUpdate();
      } else {
        return this.handleAdd();
      }
    },

    async handleAdd() {
      if (!(await this._validate())) {
        notify.error(
          "Form validation failed, please check your inputs and try again."
        );
        return Promise.reject();
      }

      try {
        return this.addSingle(this.newStack)
          .then((response) => {
            //Redirect to new opp
            this.close()
            this.$emit('created')
          })
          .catch((error) => {
            if (error.response.status === 422) {
              notify.error(
                "Form validation failed, please check your inputs and try again."
              );
            } else {
              console.error(error);
              notify.error("Failed to create Sign-Off, please try again.");
            }
          });
      } catch (error) {
        console.error(error);
      }
    },

    async handleUpdate() {
      if (!(await this._validate())) {
        notify.error(
          "Form validation failed, please check your inputs and try again."
        );
        return Promise.reject();
      }

      try {
        return this.updateSingle({
          id: this.newStack.id,
          payload: this.newStack,
        })
          .then((response) => {
            //In case client was changed, refresh the state from the api repsonse
            this.setClient(response.data.client);

            notify.success("Stack successfuly updated.");
            this.close();
            this.$emit("updated");
          })
          .catch((error) => {
            if (error.response.status === 422) {
              notify.error(
                "Form validation failed, please check your inputs and try again."
              );
            } else {
              console.error(error);
              notify.error("Failed to create budget, please try again.");
            }
          });
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
